module.exports = __webpack_public_path__ + "img/igluglow - copia.5b66bac8.jpg";